export const SET_JOB_RESPONSE = 'SET_JOB_RESPONSE'
export const SET_JOB_RESPONSE_COUNT = 'SET_JOB_RESPONSE_COUNT'
export const SET_PROFILE = 'SET_PROFILE'
